import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import "./App.css";



class Nfo extends Component {


  renderThumb() {
 
    const thumbStyle = {
      
        backgroundColor: 'rgba(255,255,255,0.2)',
        borderRadius: '100px',
  
    };
    return (
        <div
            style={{ ...thumbStyle }}
     />
    );
}

render(){

   
     if (this.props.nfo === "About Fucking Time"){
    return (  <Scrollbars renderThumbVertical={this.renderThumb} style={{ height: 400, overflowX: 'hidden' }}><pre>{`
    _________                                   __/\\__     _____              ____
            /_ ______ ______ ______ _________ __\\    /____/    /______ _____ /    
        __   / __   / __   / ___  /     /__ / __/_  _\\   / /  / __   /     /  ____ 
       _//  /  //  /  //  /  /_/_/  /  /       /  \\/  /   /  / _//  /_   _/ ____/_
        /__/  /___/  /___/__/  \\/_____/___/___/___/  /___/__/___/__//___/_        
    ___/ /___/  /___/     /_____\\               /___/                    /________
                                                                              !ne7
                    presents a melting pot of joy for all the family              
                                                                                  
                              ..........................                          
                                                                                  
                                                                                  
    So here it is.  "About f*****g time", by Approximate.  After 8 years of       
    silence, we finally produced something.  Finished about 30 seconds before the 
    compo started, we're all a bit knackered.                                    
                                                                                  
    Should run on an average Linux box with a 3D graphics card.  Video to follow  
    for the windows crowd :-)                                                     
                                                                                  
    Approximate - Cryptic, MeteoriK, Velo                                         
`}</pre></Scrollbars>);
  }
  else if(this.props.nfo === "Gaia Machina"){
    return (<Scrollbars renderThumbVertical={this.renderThumb} style={{ height: 400 }}><pre>{`
    --------------------------------------------------------------------------------
                                                                        ___          
      ________                            ____        .       __       /  /          
      \\       \\        _______            \\   \\  ____.%. __  /  \\ /\\  /  /_  _____   
      _\\       \\ _____/  __   \\____   _____\\   \\/   /__ /  \\/    \\  \\/  __/ / __  \\  
     /  \\___   / __   \\  \\/    \\   \\ /  __  \\      /   |         /  /  /   \\  \\___/  
    /     \\/  /  \\/    \\ /_____/___//_  \\/  /      \\   |__\\  /__/   \\_______\\ __/___ 
    \\_____/\\_/   /      \\__\\|   \\/    \\    /___/\\___\\  |   \\/ /        \\ /_________/ 
            /   /_______/   |   /\\     \\____/      |___|     /          \\            
           /        \\  _____|__/_ \\_____\\___.__'%'_ ________/____________\\            
          /__________\\/          \\ \\         \\  '  \\\\          \\                     
                      \\     _____/__\\______   \\     \\\\_______   \\                    
                       \\    \\_      \\    \\/    \\     \\/    \\/    \\                   
                        \\     \\      \\     /    \\     \\      /    \\                  
      _____  ____ _______\\___________/____/\\_____\\_'%'_\\____/\\_____\\ ___________     
     /     \\/    \\\\          \\/         \\   \\     \\ '   \\     \\     \\\\          \\    
    /       \\     \\\\_______   \\    _____/__  \\     \\     \\     \\     \\\\_______   \\   
    \\     __  __   \\/    \\/    \\   \\/      \\        \\     \\     \\/    \\/    \\/    \\  
     \\    \\/  \\/    \\      /    \\          /   \\     \\     \\   /\\      \\      /    \\ 
      \\____\\___\\____/\\____/\\_____\\________/_____\\_____\\_____\\____\\_____/\\____/\\____/ 
                                                                              !NE7 


         A  P  P  R  O  X  I  M  A  T  E   -   G  A  I  A    M  A  C  H  I  N  A
                                 
                                 F I N A L  V E R S I O N 
    
                                     F O R  G I L E S

                                 6 Dec 1976 - 3 Oct 2012


    --------------------------------------------------------------------------------
    http://approximate.se/

    Final Notes:

    We started working on a final version straight after Revision 2012 and we had
    planned to release it much sooner. However, the unexpected and tragic passing 
    of our good friend and third member, Giles "meaty" Constant, the coder of
    our synth Mapprox, naturally got in the way of things.
    We are back now however so expect to see more of us soon!
    Scenes have been changed and things optimized. Music has been left untouched.

    This one is for you Giles, we miss you! 




    Texture quality setting:

    Use low if the intro crashes during startup in order to decrease memory
    usage. Use high if you experience any graphical glitches. There
    have been reports of block distortions on some hardware. In particular on
    text and the strawberry glow effect.






    Original Notes:

    Cryptic: 
    One hour of sleep so far at Revision. Deadline approaching rapidly.
    Some performance issues remain and the intro has not been tested on AMD for
    a couple of days so there might be some shader issues remaining. 
    Expect a final soon. As usual, bad anti virus software might wrongfully flag
    anything touched by the kkrunchy packer as a virus. This is a
    false positive. Just ignore it. Hope you enjoy!

    Giles: Hurrah!  First outing for the new synth in the first intro from
    approximate for nearly 3 years!  Engine rewrites are now usable, so expect
    more from this space..  see you all at assembly..   word!  ~meaty

    Velo: Yes yes yall. Rockin revision like one should. Made the music, got drunk,
    made some more, woke up, removed some. Right now cryptic is stressed. Meaty is
    on irc and im boozing. I love not being a coder.


    Greetings to:

    #ukscene allstars, Fairlight, EDiS, Tulou, Ate bit, Scullar, Triad,  DCS,
    Nature, flowersFX, Outbreak, Conspiracy, cellfish, Ctrl-Alt-Test, Razor1911,
    Traktor, Whazzah, SystemK, Farbrausch, The Gang, rgba and thanks to xwize 
    for coming up with the name.

    Packed using kkrunchy by ryg^farbrausch
`}</pre></Scrollbars>);
  }

  else if(this.props.nfo === "Ephemera"){
    return (<Scrollbars renderThumbVertical={this.renderThumb} style={{ height: 400 }}><pre>{` 
    !ne7                                    ___________        ______            
    _______       ________            _____|     //__ /\\       \\    /_            
    \\      \\ _____\\__     \\    _______\\    |    /_\\__ \\ \\    _/   ___/\\           
   /   ___  \\\\       \\___  \\___\\      \\\\__   __//   /\\_\\/____\\_   /__\\_\\____      
  /    \\_/   \\ ___   /\\_/  /   \\  ___  \\        \\  / _\\ \\      \\        /   \\     
  \\     /    / \\_/  / ____/___  \\ \\_/   \\  |    / /-/  \\/  ___  _______/___  \\    
  \\____/\\___/ _____/  /    \\_/___       /  |___/ / /   \\   \\_/   \\_/    \\_/__/_   
  /   / //     /_____/          \\______/---'/___//      \\   /    /\\           /   
 /___/\\//_____/     / \\____/     \\     \\  / \\    /--/____/__/____/  \\_________/    
       /     /_____/  /   /_______\\ ____\\/ /_\\__\\  \\    \\  \\   \\  /\\        \\    
      /_____/       \\/___/         \\       \\     \\  \\____\\__\\___\\/  \\________\\   
                        /___________\\       \\_____\\                               
    .                                                 +                           
                  .                                          *                    
           +                p   r   e   s   e   n   t               __/\\__        
     .                                                 .            \\    /....    
        _________                  __                               /_  _\\  ::    
       /        /\\    ____    ___ /_/\\    +                           \\/    ::    
      /        /__\\__/   /__ /  /_\\_\\/____ __ ________    _______  ________ ::    
      \\  _____/ \\  _    _   /      //    //  /\\       \\  /\\      \\/\\       \\ :    
     /        //  //   //  /       /    //   /   ______\\ /    __  \\/  ____  \\     
    /   _____//  //   //  /   _   /    //   /   _____/_ /    /_/  /  /__ /   \\    
    \\   \\/     \\ ~    ~  /   //   \\    ~   \\    \\/     \\    /    /      /    /    
     \\_________/    ____/___//    /   _____/\\__________/   /____/\\_____/____/     
      \\        /___/\\   \\   /____/___/\\   / /        /____/    / /     /   / :    
       \\_______\\   \\ \\___\\__\\    \\   \\ \\_/\\/________/    /____/_/____//___/ ::    
                \\___\\/       \\____\\___\\/           /____/                   ::    
      ......                                                                ::    
   .. :   ::                                                        ........::    
   :  :   :                                                         ::            
   :..: ___/\\                                                       ::            
        \\    \\___            approximate > ephemera               /\\:             
         \\      /                                             ___/  \\____         
         /     /                                              \\         /         
        /___  _\\         f o r  s u n d o w n  2 0 0 9  !      \\       /          
            \\/                                                 /__    _\\          
          :             ..................................        \\  /            
          ::                                                       \\/ :           
          ::::::::                                                    :: :::::    
                ::                                                    :: :: ::    
                ::                                                    ::    ::    
              /\\ :                                          :::::::   ::::::::    
             /  \\___          code: cryptic                 ::   ::               
         ___/      /                                        ::   ::      ::       
         \\        /                                         ::           ::       
          \\       \\           synth/music: meaty            :::::::::::::::       
          /___  ___\\                                                              
              \\/                                                 ::               
             :                graphics/design: cryptic & velo    ::               
             ::                                                  ::::::           
             :::::::                                                 : /\\         
      ::::::      ::                                                  /  \\__      
      ::  ::      ::                                               __/     /  .   
      ::          ::                                               \\       \\    . 
      ::::::::::::::                                                \\       \\     
                                                                    /___  ___\\    
          ::                                                            \\/        
          ::                                                           :          
          ::                                                           ::         
          ::                                                           ::         
            /\\                greets: #ukscene allstars,               ::         
        ___/  \\__                                                      ::         
        \\       /             fairlight, ate bit, scullar,             ::         
         \\     /                                                       : /\\       
          \\    \\              triad, tulou, bcs, fyllecell,           __/  \\__    
          /_  __\\                                                     \\      /    
            \\/                outbreak, yodel, traktor,               /     /     
              :                                                      /___  _\\     
              ::              speedfisters, alcatraz,                    \\/       
              ::                                                           :      
              ::              databrothers and youth uprising!             ::     
               :                                                           ::     
               :                                                            :     
                                                                                  
               :                                                            :     
                                                                                  
               .                                                            .     
                                                                                  
                                                                                  
                                                                                  
                                                                                  
                                                                                  
                                                                                  
      Three days with approximately 2 hours sleep each. Demoparty business as     
      usual. Finally I can join velo and meaty for some well deserved beer. It's  
      not easy beeing the designated coder :) Very proud to present this product  
      which was orginally planned for release at assembly but pushed beyond the   
      deadline due to various hardships. Now beer! ~cryptic                       
                                                                                  
                                                                                  
                                                                                  
                                                                                  
      This 64k intro was brought to you by 6 pizzas, a blocked toilet, 150 cans   
      of lager and a broken festival chair.  mmm, these fish and chips are        
      delicious.  MORE BEER!!!!!   GIMME MORE BEER!!!!!!!!  burp.  Parapete       
      is sitting opposite us, and his beard makes him look like a playmobil       
      man.  Chilli sauce all round!  Respects to /Qfist for the worst             
      show-stopping synth bug in history!   ~meaty                                
                                                                                  
                                                                                  
                                                                                  
      Sundown 09, what can i say... Awsome party, lovely people great beer and    
      in a few hours hopefully the best bonfire since the first Breakpoint party! 
      Respects to rolf for the moral support at asm, respects to ne7 for the      
      awsome ascii-art! Gonna have a few more beers now. HATTEN! ~velo            
`}</pre></Scrollbars>);
  }

  else if(this.props.nfo === "Small Matters of the Heart"){
    return (<Scrollbars   renderThumbVertical={this.renderThumb} style={{ height: 400 }}><pre>{`
                                                                      ___
    ________                            ____        .       __       /  /         
    \\       \\        _______            \\   \\  ____.%. __  /  \\ /\\  /  /_  _____  
    _\\       \\ _____/  __   \\____   _____\\   \\/   /__ /  \\/    \\  \\/  __/ / __  \\ 
   /  \\___   / __   \\  \\/    \\   \\ /  __  \\      /   |         /  /  /   \\  \\___/ 
  /     \\/  /  \\/    \\ /_____/___//_  \\/  /      \\   |__\\  /__/   \\_______\\ __/___
  \\_____/\\_/   /      \\__\\|   \\/    \\    /___/\\___\\  |   \\/ /        \\ /_________/
          /   /_______/   |   /\\     \\____/      |___|     /          \\           
         /        \\  _____|__/  \\_____\\                   /____________\\          
        /__________\\!NE7                                                          
  
  
  
                                A P P R O X I M A T E                             
  
                   S M A L L  M A T T E R S  O F  T H E  H E A R T                
  
                           F O R  R E V I S I O N  2 0 1 5                        
  
                               Code and GFX: Cryptic                              
                                    Music: Velo
                                  Synth: Meteorik                                 
  
  
  --------------------------------------------------------------------------------
  
  
  
  Cryptic:
  Finally we are back with a new intro! First one with our new engine. Not a 
  lot of time for proper design this time around since most time has been spent on
  coding and bugfixes but at least we got something released. Expect a           
  cleaned up final to follow in the not to distant future when we have recovered 
  from the party deadline crunching.
  
  
  
  Velo:
  So here we are, once again at Revision getting no sleep. It feels great 
  releasing something new finally,especially in a compo like this, 
  I hope you enjoy! Consider this a party version that needs polishing, 
  we did not have time to fit all the things we wanted so expect a final version 
  (hopefully not two years from now).
  
  There are some artifacts in the sound that may or may not be noticeable, 
  just pretend its an old vinyl. It will probably, among other things, be fixed 
  in a final version.
  
  
  --------------------------------------------------------------------------------
  
  No room in this party version, but greets fly out to:
  
  Mercury, Conspiracy, Ctrl-Alt-Test, Brain Control, Fairlight, Farbrausch, 
  Censor, #ukscene allstars, EDiS, Tulou, Ate bit, Scullar, Triad,  DCS, Nature, 
  FlowersFX, Outbreak, Cellfish, Razor1911, Traktor, Whazzah, SystemK, The Gang, 
  RGBA, Panda Cube, rtificial
  
  Packed using kkrunchy by ryg^farbrausch
  `}</pre></Scrollbars>);
  }

  else if(this.props.nfo === "Surge Response"){
    return (<Scrollbars   renderThumbVertical={this.renderThumb} style={{ height: 400 }}><pre>{`
    
                                                                      ___
    ________                            ____        .       __       /  /         
    \\       \\        _______            \\   \\  ____.%. __  /  \\ /\\  /  /_  _____  
    _\\       \\ _____/  __   \\____   _____\\   \\/   /__ /  \\/    \\  \\/  __/ / __  \\ 
   /  \\___   / __   \\  \\/    \\   \\ /  __  \\      /   |         /  /  /   \\  \\___/ 
  /     \\/  /  \\/    \\ /_____/___//_  \\/  /      \\   |__\\  /__/   \\_______\\ __/___
  \\_____/\\_/   /      \\__\\|   \\/    \\    /___/\\___\\  |   \\/ /        \\ /_________/
          /   /_______/   |   /\\     \\____/      |___|     /          \\           
         /        \\  _____|__/  \\_____\\                   /____________\\          
        /__________\\!NE7                                                          
                                                                                  
                                                                                  


                                  A P P R O X I M A T E                             

                                S U R G E  R E S P O N S E

                             F O R  R E V I S I O N  2 0 1 7                        

                              Code, Synth and GFX: Cryptic                          
                                      Music: Velo




    --------------------------------------------------------------------------------


    Greets fly out to:

    Mercury, Conspiracy, Ctrl-Alt-Test, Brain Control, Fairlight, Farbrausch, 
    Censor, #ukscene allstars, EDiS, Tulou, Ate bit, Scullar, Triad,  DCS, Nature, 
    FlowersFX, Outbreak, Cellfish, Razor1911, Traktor, Whazzah, SystemK, The Gang, 
    RGBA, Panda Cube, rtificial, FEE1DEAD 

    Packed using kkrunchy by ryg^farbrausch                                        
`}</pre></Scrollbars>);
  }
  else {
      return false;
  }
}
}
  export default Nfo;
  


// WEBPACK FOOTER //
// ./src/nfo.js